import { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  defaults,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

defaults.font.family = "Montserrat";

type Props = {
  data: {
    label: string;
    value: number;
  }[];
  getTooltip?: any;
  yAxisFormatter?: any;
  labelFormatter?: any;
};

export default function BarChart({
  data: dataProps,
  getTooltip = () => "",
  yAxisFormatter = () => "",
  labelFormatter = () => "",
}: Props) {
  const options = {
    elements: {
      bar: {
        borderWidth: 0,
      },
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "top" as const,
      },
      tooltip: {
        callbacks: {
          footer: getTooltip,
          label: labelFormatter,
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        min: 0,
        ticks: {
          callback: yAxisFormatter
        }
      },
    },
    borderWidth: 1,
  };

  const data = useMemo(
    () => ({
      labels: dataProps.map(({ label }) => label),
      datasets: [
        {
          data: dataProps.map(({ value }) => value),
          backgroundColor: [
            "#00EFEF",
            "#0089A9",
            "#06B2DA",
            "#51E0C4",
            "#25BB9D",
          ],
        },
      ],
    }),
    [dataProps]
  );

  return <Bar options={options} data={data} />;
}
